import React, { useContext } from 'react'
import ImageWithBasePath from './ImageWithBasePath'
import classNames from 'classnames'
import { BREAD_CRUMBS_DATA, PATHNAME_WITH_ASPATH, SITEMAP } from '../constants/advertiser'
import { NextLink } from '../commonComponents/NextLink'
import { useRouter } from 'next/router'
import Head from 'next/head'
import { getBreadcrumbSchema } from '../utils/Schemas'
import { SharedContext } from '../context/SharedContext'

export const Breadcrumbs = () => {
  const { historyStack, setHistoryStack, location } = useContext(SharedContext)
  const router = useRouter()

  const pathname = router?.pathname?.split('/')?.[1]
  const pageBreadcrumbs = [
    ...(Array.isArray(BREAD_CRUMBS_DATA?.[pathname]) ? BREAD_CRUMBS_DATA?.[pathname] : [])
  ]

  const isSitemapPresent = () => {
    let isPresent = false
    const stack = [...(Array.isArray(historyStack?.data) ? historyStack?.data : [])]
    for (let item of stack?.reverse()) {
      if (item?.pathname == '/seekerHomePage') break
      if (item?.pathname == '/sitemap') isPresent = true
    }
    return isPresent
  }

  if (
    isSitemapPresent() &&
    pathname != '/sitemap' &&
    pageBreadcrumbs?.[1]?.pathname != '/sitemap'
  ) {
    pageBreadcrumbs?.splice(1, 0, SITEMAP)
  }

  const redirectHandler = async (item) => {
    if (item === router?.pathname) return
    let breadCrumbs = [...(Array.isArray(historyStack?.data) ? historyStack?.data : [])]
    let count = 0
    while (breadCrumbs[breadCrumbs?.length - 1]?.pathname != item && breadCrumbs?.length != 0) {
      breadCrumbs?.pop()
      count = count + 1
    }
    const index = historyStack?.data?.length - count
    if (breadCrumbs?.length === 0 || !(historyStack?.[index]?.pathname == item)) {
      return false
    } else {
      history?.go(-count)
      setHistoryStack((prv) => {
        prv.isForword = false
        prv.isBack = true
        prv.data = [...breadCrumbs]
        return { ...prv }
      })
    }
    return true
  }

  pageBreadcrumbs.forEach((breadcrumb) => {
    historyStack['data'].reverse().every((stack) => {
      if (breadcrumb['pathname'] === stack['pathname']) {
        breadcrumb['as'] = stack['as']
        return false
      }
      return true
    })
  })

  return (
    <>
      <Head>
        <script type="application/ld+json">
          {JSON.stringify(getBreadcrumbSchema(pageBreadcrumbs))}
        </script>
      </Head>
      <div className="flex flex-wrap font-noto-sans text-[11px] font-bold leading-[14.98px] tracking-[1px]">
        {(pageBreadcrumbs || [])?.map((item, index) => {
          const isLastIndex = pageBreadcrumbs?.length - 1 == index
          return (
            <div className="flex items-center" key={index}>
              <NextLink
                onClick={async () => await redirectHandler(item?.pathname)}
                className={classNames(
                  'select-none',
                  !isLastIndex ? 'text-[#97989B]' : 'text-[#4B4B4E]'
                )}
                href={item || 'seekerHomePage'}
                as={
                  location
                    ? `jobs/${(location?.name || location?.title).toLowerCase()}`
                    : `${PATHNAME_WITH_ASPATH?.[item?.pathname]}`
                }
                isLoader={false}
                id={item?.name + index}
              >
                {item?.name || ''}
              </NextLink>
              {!isLastIndex && (
                <div className="relative mx-[4px] h-[8px] w-[8px]">
                  <ImageWithBasePath src="bread_arrow_forward" fill alt="forward arrow" />
                </div>
              )}
            </div>
          )
        })}
      </div>
    </>
  )
}
